<template>
  <div class="content-page mobile-app">
    <div class="main-page">
      <div class="title-page">特别提醒事项</div>
      <div class="backgroundBox" >
        <div class="main-contentBox" v-show="contentList.length>0">
        <div class="star-title">
          <span class="star"></span>特别提醒事项
        </div>
        <div class = "contentBox tip-contentBox">
            <div class="textBox" >
              <div class="paragraph" v-for="(item,index) in contentList" :key="index" >
               {{item.content}}
                 <div class="text-content" v-for="(ite,index) in item.children" :key="index" >
                   {{ite.content}}
                 </div>
              </div>
            </div>
        </div>
        <p class="checked-text"><el-checkbox v-model="checked"></el-checkbox> &nbsp;&nbsp;我已阅读，接受上述规定，愿意承担相关法律责任并做好了准备，希望进行网上申请操作。</p>
        <div class="btnLists">
          
          <div class="border-btn" @click="$router.push('/m-codeSearch')" >返回上一页</div>
          <div @click="interApply" v-if="isShow"  class="primary-btn">进入网上申请 <span v-if="!isShow"> ( {{downNumber}} ) </span> </div>
          <div class="gary-btn" v-else>进入网上申请 ( {{downNumber}} )  </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@api/api'
export default {
  data () {
    return {
      contentList: [],
      checked: false,
      isShow: false,
      downNumber: 5 // 倒数字
    }
  },
  created () {
    this.startDownNumber()
    this.getDescribeTex()
  },
  methods: {
    getDescribeTex () {
      Api.getDescribeTex({ type: 'remind' }).then(res => {
        this.contentList = res.data.data
        console.log(res.data.data)
      })
    },
    // 倒计时
    startDownNumber () {
      this.isShow = false
      this.downNumber = 5
      var times = setInterval(() => {
        this.downNumber--
        if (this.downNumber <= 0) {
          this.isShow = true
          clearInterval(times)
        }
      }, 1000)
    },
    // 进入网上申请
    interApply () {
      if (!this.checked) {
        this.$toast('请先阅读网上申请须知')
        return
      }
      this.$router.push('/m-howApply')
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1000px) { 

  .contentBox{
    display: block !important;
  }
}

.main-contentBox{
  width: 100%;
  padding: 16px;
  .star-title{
    margin-bottom: 16px;
  }
  .tip-contentBox{
    height: 418px;
    overflow: auto;
    .textBox{
      padding:16px;
    .paragraph{
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #000;
      line-height: 24px;
    }
    .text-content{
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: rgba($color: #000000, $alpha: 0.6);
      line-height: 24px;
      margin-left: 16px;
    }
  }
  }
  .checked-text{
    margin-top: 16px;
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    color: rgba($color: #000000, $alpha: 0.6);
    width: 100%;
    // height: 100px;
  }

  .btnLists {
    margin: 16px 0;
    justify-content: space-between;
    align-items: center;
    div {
      width: 47.5%;
      height:48px;
      font-size: 16px;
      line-height: 48px;
      color:#cbb486
    }
    .border-btn {
      color: #000000;
    }
    .primary-btn {
      color: #fff;
    background: linear-gradient(
90deg
, #e4c995 0%, #b9916a 100%);
    }
    .gary-btn {
      color: #fff;
    }
  }
  
}
.backgroundBox {
    padding-bottom: 0!important;
  }
</style>
